import DashboardLayout from '../components/DashboardLayout';
import KpiCards from './KpiCards';
import ChartsRow from './ChartsRow';
import PanelsRow from './PanelsRow';
import BottomPanels from './BottomPanels';

export default function DashboardHome() {
  return (
    <DashboardLayout>
      <div className="space-y-4">
        <KpiCards />
        <ChartsRow />
        <PanelsRow />
        <BottomPanels />
      </div>
    </DashboardLayout>
  );
}
